const info = {
  ZH: { //中文翻译
    title: 'MDS/组件单元分析',
    analysetype: '分析类型',
    decomposition: '统计方式',
    type: '类型:',
    ver: '版本:',
    orgname: '材料数据表 供应商:',
    name: '名称:',
    symbol: '内部材料号:',
    calWeightPerItem: '质量:',
    standartion: '标准材料号:',
    materialclass: '物质分类:',
    basicmaterial: '基本物质',
    basicmaterialclass: '基本物质分类',
    materials: '材料',
    materialsclass: '材料分类',
    confidentialmateria: '保密物质',
    percentage: '百分比[%]',
    quality: '质量[g]',
    nodeweight: '顶端节点质量的计算',
    sumnodeweight: '子节点计算质量的总和 (是随后分析处理的基础)',
    totalPositiveWarpWeight: '子节点正偏差值的总和',
    totalMinusWarpWeight: '子节点负偏差值的总和',
    totalWeight: '顶端节点的计算质量',
    othernodeweight: '其他顶端节点的有关数据(与分析处理无关)',
    singleweight: '单个的测量质量',
    error: '允许误差',
    warp: '偏差',
    sumWeight: '质量总计[g]：',
    sumRate: '百分比总计[%]：',
    export: '导出',
    select: '选择',
    analyse: '分析',
    zeroWeight: '零部件的质量为零！',
    select1: '没有数据,请点选择键！',
    selectAll: '全选',
    ok: '确定',
    cancel: '取消',
    cas: 'CAS 编号',
    materialsid: '材料ID号',
    materialsclassid: '材料分类号',
    description2: '基本物质分类名称',
    description1: '基本物质名称',
    description3: '材料名称',
    description4: '材料分类名称',
    extraClass: '额外分类',
    level: '层级',
    title1: '本页面可以帮助您查找特定表单的被引用位置。通过如下【查找】按钮搜索您想要查找的表单信息。',
    title2: '之后点击【搜索】，即可查找到所有引用该表单的数据信息。',
    mds: '需要查找的表单',
    query: '查找',
    mdsname: '零部件/半成品/材料名称',
    cysmbol: '零部件/半成品/材料号',
    suppler: '供应商',
    search: '搜索',
    noselect: '请添加需要查找的表单！',
    mdsType: '表单类型',
    accord: '按照 "表单类型"分类(零部件-半成品-材料) - 同时"创建时间"倒序排列',
    selfMds: '自建的',
    receiveMds: "\u5DF2\u63A5\u6536",
    dateFrom: " \u4ECE",
    dateTo: "\u81F3",
    dateScope: " \u65E5\u671F\u8303\u56F4\uFF1A:",
    createDate: " \u521B\u5EFA\u65F6\u95F4",
    mdsTypeText: " \u4EA7\u54C1\u7C7B\u578B",
    componentText: " \u96F6\u90E8\u4EF6",
    materialText: " \u6750\u6599",
    semiComponent: " \u534A\u6210\u54C1",
    status: " \u72B6\u6001",
    status_N: " \u5C1A\u672A\u6D4F\u89C8",
    status_S: " \u5DF2\u6D4F\u89C8",
    status_A: " \u5DF2\u6279\u51C6",
    status_R: " \u5DF2\u62D2\u7EDD",
    status_M: " \u7F16\u8F91\u4E2D",
    status_C: "\u88AB\u53D1\u9001\u4EBA\u53D6\u6D88",
    status_D: " \u5DF2\u88AB\u4E0B\u8F7D",
    searchText: "\u67E5\u8BE2",
    supplierText: "\u4F9B\u5E94\u5546",
    serialnumber: "序号",
    childCompName: '子部件名称',
    percentageOfMater: '\u5728\u6750\u6599\u4E2D\u7684\u6BD4\u4F8B',
    appOption: '\u5E94\u7528\u9009\u9879',
    check_materialName: "请输入物质！",
    coption: "\u5E94\u7528\u9009\u9879\u63CF\u8FF0",
    subGropName: "\u5BF9\u5E94\u7269\u8D28",
    delFlag: "\u9009\u9879\u6709\u6548\u6027",
    index: "\u5E8F\u53F7",
    confirm: "\u786E\u5B9A",
    return: "\u53D6\u6D88",
  },
  EN: { //英文翻译
    title: "MDS/module Analysis",
    analysetype: "Analysis type:",
    decomposition: "Statistical Method",
    type: "Type:",
    ver: "Version:",
    orgname: "MDS Supplier:",
    name: "Article Name:",
    symbol: "Internal Material No.:",
    calWeightPerItem: "Mass:",
    standartion: "Standard Material No.:",
    materialclass: "Substance classification:",
    basicmaterial: "Basic substance",
    basicmaterialclass: "Basic substance group",
    materials: "Material",
    materialsclass: "Material classification",
    confidentialmateria: "Confidential Substance",
    percentage: "Percentage  [%]",
    quality: "Mass [g]",
    nodeweight: 'Calculation of top nodes\' qulity',
    sumnodeweight: 'The sum of the calculated mass of child nodes (as the basis of the subsequent analytical processing)',
    totalPositiveWarpWeight: 'The sum of the positive deviation values of child nodes',
    totalMinusWarpWeight: 'The sum of the negative deviation values of child nodes',
    totalWeight: 'The calculated qulity of top nodes',
    othernodeweight: 'The relevant data of other top nodes (irrelevant to analytical processing)',
    singleweight: 'Single measured qulity',
    error: 'Tolerances',
    warp: 'Deviation',
    sumWeight: 'Total weight[g]:',
    sumRate: 'Total rate[%]:',
    export: 'export',
    select: 'Select',
    analyse: 'Analyze',
    zeroWeight: 'Component weight is Zero',
    select1: 'No data. Please click on the Select key!',
    selectAll: 'Select all',
    ok: 'OK',
    cancel: 'Cancel',
    cas: 'CAS No.',
    materialsid: 'Material ID',
    materialsclassid: 'Material Classification',
    description2: 'Basic substance Group',
    description1: 'Basic substance Name',
    description3: 'Material Name',
    description4: 'Description',
    extraClass: 'Extra Classification',
    level: 'level',
    title1: 'This function will assist you to find the reference relationship of the MDS. You can search the MDS by [Search] button to find the special MDS.',
    title2: 'Then click on [Continue] to find out all the MDSs which reference the special MDS.',
    mds: 'MDS to find',
    query: 'Search',
    mdsname: 'mds name',
    cysmbol: 'cysmbol',
    suppler: 'suppler',
    search: 'Search',
    noselect: 'Please add the form！',
    mdsType: 'Mds Type',
    accord: 'Sort by form type (component-semi-material) - and arrange in reverse order of creation time',
    selfMds: 'Self-created',
    receiveMds: 'Receive MDS',
    dateFrom: ' From',
    dateTo: 'To',
    dateScope: ' DateScope:',
    createDate: ' createDate',
    mdsTypeText: ' mdsType',
    componentText: ' component',
    materialText: ' material',
    semiComponent: ' semiComponent',
    status: '	Status',
    status_N: '	not yet browsed',
    status_S: '	Viewed',
    status_A: '	Accepted',
    status_R: '	Rejected',
    status_M: 'Edit mode',
    status_C: 'Canceled by sender',
    status_D: 'Downloaded',
    searchText: 'search',
    supplierText: 'supplier',
    serialnumber: "No.",
    childCompName: "Child Component Name",
    percentageOfMater: "Percentage of Material  [%]",
    appOption: "Application Option",
    check_materialName: "Please input the name of material!",
    coption: "Option",
    subGropName: "Group Name",
    delFlag: "Availability",
    index: "Number",
    confirm: "Confirm",
    return: "Return",
  }
}
export default info //需要暴露出去
